import Vue from 'vue'
import axios from 'axios'
import Jimp from 'jimp'

function initialState() {
  return {
    fields: [],
    loading: false,
    editedField: {},
    error: null
  }
}
function getResizedImage(data) {
  Jimp.read(data)
    .then(image => {
      image
        // .scaleToFit(128, 128, Jimp.AUTO)
        .getBuffer(Jimp.AUTO, (err, buffer) => {
          if (err) {
            return
          }
          return buffer
        })
    })
    .catch(err => console.log('transform err'))
}
export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    setFields(state, fields) {
      state.fields = fields
    },
    add(state, field) {
      state.fields = [...state.fields, field]
    },
    delete(state, field) {
      state.fields = state.fields.filter(f => f._id != field._id)
    },
    update(state, field) {
      let index = state.fields.findIndex(f => f._id === field._id)
      state.fields = [...state.fields]
      state.fields[index] = field
    },
    clear(state) {
      const initState = initialState()
      state = initState
    },
    setEditedField(state, field) {
      state.editedField = field
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    clear({ commit }) {
      commit('clear')
    },
    setEditedField({ commit }, field) {
      commit('setEditedField', field)
    },
    async load({ commit }) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios
          .get(`${process.env.VUE_APP_API_URL}/fields`)
          .then(res => res.data.fields)
          .then(fields => {
            commit('setFields', fields)
          })
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async loadActive({ commit }) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios
          .get(`${process.env.VUE_APP_API_URL}/fields/active`)
          .then(res => res.data.fields)
          .then(fields => {
            commit('setFields', fields)
          })
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },

    async add({ dispatch, commit }, { data, images }) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/fields/add`, { field: data })
          .then(res => res.data.id)
          .then(fieldId => {
            if (Object.keys(data.attrs.options).some(optId => data.attrs.options[optId].imgId)) {
              dispatch('images/saveFieldImages', { field: data, fieldId, images }, { root: true })
            }
            commit('add', { data, _id: fieldId })
          })
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async update({ state, commit, dispatch }, { field, images }) {
      commit('setLoading', true)
      commit('setError', null)
      const prevField = state.fields.filter(f => f._id == field._id)[0]
      const newImgIds = field.data.attrs.options.map(opt => opt.imgId)
      const prevImgIds = prevField.data.attrs.options.map(opt => opt.imgId)
      const imgIdsToDelete = prevImgIds.filter(id => !newImgIds.includes(id))
      const imagesToAdd = newImgIds.reduce((newImages, id) => {
        if (!prevImgIds.includes(id)) newImages[id] = images[id]
        return newImages
      }, {})
      try {
        await axios.put(`${process.env.VUE_APP_API_URL}/fields`, field)
        commit('update', field)
        if (imgIdsToDelete.length > 0) {
          dispatch('images/deleteImages', imgIdsToDelete, { root: true })
        }
        if (Object.keys(imagesToAdd).length > 0) {
          dispatch(
            'images/saveFieldImages',
            { field: field.data, fieldId: field._id, images: imagesToAdd },
            { root: true }
          )
        }
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    },
    async delete({ commit }, field) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        await axios.delete(`${process.env.VUE_APP_API_URL}/fields/${field._id}`)
        commit('delete', field)
      } catch (err) {
        commit('setError', err)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    allFields: state => {
      return state.fields
    },
    isLoading: state => {
      return state.loading
    },
    isError: state => {
      return state.error
    }
  }
}
